import { useState } from "react";
import TableInputValue from "@/Layouts/components/InputComponents/TableInputValue";
import { NumberOrString } from "@/Layouts/components/InputComponents/InputValue/types";

interface IInputEditMoneyCellProps {
	error: boolean;
	hasFocus: boolean;
	value?: NumberOrString;
	editComplete?: (value: NumberOrString) => void;
	disabled?: boolean;
}

const InputEditMoneyCell = (props: Readonly<IInputEditMoneyCellProps>) => {
	const { error, hasFocus, editComplete, disabled = false } = props;
	const [value, setValue] = useState(props?.value ?? 0);

	const handleChange = (inputValue: NumberOrString) => {
		if (editComplete) {
			editComplete(inputValue);
		}
		setValue(inputValue);
	};

	return (
		<TableInputValue
			isControlledApi={true}
			isEditingMode={hasFocus}
			isRequiredOnChange={true}
			data={[
				{
					type: "Dollar",
					min: 0.01,
					max: 100000,
					decimalsEditable: true,
					decimals: 2,
				},
			]}
			value={{
				value,
				input: "Dollar",
			}}
			sx={{ height: "27px" }}
			onChange={(updated) => handleChange(updated)}
			error={!value || error}
			disabled={disabled}
		/>
	);
};

export default InputEditMoneyCell;
